import { useState, useEffect } from 'react';
import client from 'libs/client';
import { SelectOption } from './useVideoSourceOptions';
import { useToast } from 'ui-kit';

export const usePlayerSearch = (searchTerm: string) => {
    const [searchResults, setSearchResults] = useState<SelectOption[]>([]);
    const [hasError, setHasError] = useState<boolean>(false);
    const { mutate: searchPlayers, isLoading } = client.playerSearchDropdown.useMutation();
    const { addErrorToast } = useToast();

    useEffect(() => {
        const trimmedSearchTerm = searchTerm?.trim();
        if (trimmedSearchTerm && (trimmedSearchTerm.length >= 2 || /^\d+$/.test(trimmedSearchTerm))) {
            setHasError(false);
            searchPlayers({ body: { searchTerm: trimmedSearchTerm } }, {
                onSuccess: (data) => {
                    const formattedResults = data?.data?.items?.map(item => ({
                        value: item.id,
                        label: `${item.firstName} ${item.lastName} (${item.id})`
                    }));
                    setSearchResults(formattedResults as SelectOption[]);
                    setHasError(false);
                },
                onError: (error: any) => {
                    setSearchResults([]);
                    setHasError(true);
                    if (error?.response?.status === 400 && error?.response?.data?.message) {
                        addErrorToast(error.response.data.message);
                    } else {
                        addErrorToast('An error occurred while searching for players');
                    }
                }
            });
        } else {
            setSearchResults([]);
            setHasError(false);
        }
    }, [searchTerm, searchPlayers]);

    const clearResults = () => {
        setSearchResults([]);
        setHasError(false);
    };

    return {
        searchResults,
        isLoading,
        hasError,
        clearResults
    };
};
